import React, { useContext, useEffect } from "react";
import Amplify, { Auth, I18n } from 'aws-amplify'
import awsconfig from "../../aws-exports";
import { AmplifyAuthenticator, AmplifySignOut, AmplifySignIn, AmplifyAuthContainer, AmplifyRequireNewPassword, withAuthenticator, Authenticator } from '@aws-amplify/ui-react'
import { AuthState, onAuthUIStateChange, VerifyCurrentUser, Translations } from '@aws-amplify/ui-components';
import { UserContext } from '../../UserContext'
import { useLocation, useHistory } from 'react-router-dom'
import './login.sass'
import proposalistSVG from './proposalist-logo.svg'

Auth.configure(awsconfig)

// THis is the main login page...

const Login = () => {
  const location = useLocation();
  const history = useHistory();
  const { authState, activeUser } = useContext(UserContext)

  useEffect(() => {
    if (authState === AuthState.SignedIn && activeUser) {
      // Once logged in, redirect to the dashboard
      const { from } = location.state || { from: { pathname: "/repdashboard" } };
      history.replace(from)
    }
  }, [authState, activeUser, location.state, history])
  
  return (
    <AmplifyAuthContainer>
      <div className='logo-wrapper'>
        <img className='img' src={proposalistSVG} ></img>
      </div>
      <AmplifyAuthenticator>
        <AmplifySignIn slot="sign-in" headerText="Sign in to Proposalist" formFields={[
          {
            type: "email",
            label: "Email",
            placeholder: "Email",
            inputProps: { required: true, autocomplete: "username" },
          },
          {
            type: "password",
            label: "Password",
            placeholder: "Password",
            inputProps: { required: true, autocomplete: "new-password" },
          },
        ]} hideSignUp>
          <div slot="federated-buttons"></div>
        </AmplifySignIn>
      </AmplifyAuthenticator >
    </AmplifyAuthContainer>
  )
}
// const Login = () => {


//   return (
//     <div className='itemsWrapper'>
//       <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', width: '100%', alignItems: 'center', height: '100vh' }}>
//         <div style={{ alignItems: 'baseline' }} >
//           <h1 style={{ fontSize: '3em' }}>proposalist.</h1>
//           <h1>Thank you for signing up, now get to proposaling!</h1>
//           <a href="javascript:window.open('','_self').close();">
//             <button>close</button>
//           </a>
//         </div>
//       </div>
//     </div>
//   )
// }
export default Login;